import React, { ReactElement, ReactNode } from 'react';

import classNames from 'classnames';

import Picture from 'src/components/CE/Picture';

import * as styles from './TeamItem.module.css';

export const TeamItemColorOptions = [
  'blue',
  'green',
  'magenta',
  'orange',
  'purple',
] as const;
type TeamItemColor = (typeof TeamItemColorOptions)[number];

interface TeamItemProps {
  children: ReactNode;
  /** CSS class name */
  className?: string | string[];
  color?: TeamItemColor;
  /** imported image */
  image?: string;
  /** HTML image alt text */
  imageAlt?: string;
}

const TeamItem = ({
  children,
  className,
  color,
  image,
  imageAlt,
}: TeamItemProps): ReactElement => {
  return (
    <div className={classNames(styles.ceTeamItem, styles[color], className)}>
      <div className={styles.ceTeamItemImg}>
        {image && <Picture alt={imageAlt} image={image} position="centered" />}
      </div>
      <div className={styles.ceTeamItemContent}>{children}</div>
    </div>
  );
};

TeamItem.defaultProps = {
  className: null,
  color: 'blue',
  image: null,
  imageAlt: 'FUF Team',
};

export default TeamItem;
